<template>
  <div id="modal" v-if="timeModal.open === true">
    <div class="modal-box">
      <h2>Select your groups Time zone:</h2>
      <div id="meeting-form">
        <form>
          <select class="normalSelect" v-model="timeZoneId">
            <option value="initial" disabled>Please select your Core Groups Timezone</option>
            <option
              value="America/Detroit"
            >Eastern Time - (UTC {{getZoneOffset("America/Detroit")}})</option>
            <option
              value="America/Indiana/Vevay"
            >Eastern Time (no daylight savings) - (UTC {{getZoneOffset("America/Indiana/Vevay")}})</option>
            <option
              value="America/Chicago"
            >Central Time - (UTC {{getZoneOffset("America/Chicago")}})</option>
            <option
              value="America/Phoenix"
            >Mountain Time (no daylight savings) - (UTC {{getZoneOffset("America/Phoenix")}})</option>
            <option value="America/Denver">Mountain Time - (UTC {{getZoneOffset("America/Denver")}})</option>
            <option
              value="America/Los_Angeles"
            >Pacific Time - (UTC {{getZoneOffset("America/Los_Angeles")}})</option>
            <option
              value="America/Anchorage"
            >Alaska Time - (UTC {{getZoneOffset("America/Anchorage")}})</option>
            <option
              value="Pacific/Honolulu"
            >Hawaii-Aleutian Time - (UTC {{getZoneOffset("Pacific/Honolulu")}})</option>
          </select>
          <button class="createMeetingBtn" type="button" @click.prevent="setTimeZone">Set time zone</button>
          <button
            v-if="this.$store.state.TimeZone.exists === true"
            class="createMeetingBtn"
            type="button"
            style="background-color:darkgray"
            @click.prevent="closeTimeZone"
          >Cancel</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import store from "../store";
import MomentTZ from "moment-timezone";

export default {
  name: "TimeZone",
  components: {},
  computed: {
    ...mapGetters(["timeModal"]),
    timeZoneIdComp: function () {
      console.log(String(store.state.TimeZone.timeZoneId));
      if (String(store.state.TimeZone.timeZoneId) !== "null") {
        return store.state.TimeZone.timeZoneId;
      } else {
        return "initial";
      }
    },
  },
  data() {
    return {
      timeZoneList: MomentTZ.tz.zonesForCountry("US"),
      timeZoneId: "",
    };
  },
  methods: {
    setTimeZone() {
      if (this.timeZoneId !== "initial") {
        const data = {
          id: store.state.coreGroupId,
          timeZoneOffset: 0,
          timeZoneId: this.timeZoneId,
          coreGroupName: store.state.coreGroupName,
          className: store.state.classTitle,
        };
        const timezoneSet = store.state.TimeZone.timeZoneId;
        console.log(String(timezoneSet));
        if (store.state.TimeZone.exists === true) {
          axios
            .put(`/api/coregroup`, data)
            .then(function () {
              store.dispatch("coregroupCheck", store.state.coreGroupId);
            })
            .catch(function (ex) {
              console.error(ex);
            });
        } else {
          axios
            .post(`/api/coregroup`, data)
            .then(function () {
              store.dispatch("coregroupCheck", store.state.coreGroupId);
            })
            .catch(function (ex) {
              console.error(ex);
            });
        }
      } else {
        alert("Please select your CoreGroup's timezone, and confirm.");
      }
    },
    getZoneOffset(timezone) {
      return MomentTZ().tz(timezone).format("Z");
    },
    closeTimeZone() {
      store.commit("showTimeModal", false);
    },
  },
  beforeMount() {
    console.log("TIMEZONE", String(store.state.TimeZone.timeZoneId));
    if (String(store.state.TimeZone.timeZoneId) !== "false") {
      this.timeZoneId = store.state.TimeZone.timeZoneId;
    } else {
      this.timeZoneId = "initial";
    }
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-modal.scss">
</style>